import { BaseContainerModel } from '../../base-container.model';
import { bl_dgmkt_unsubscribed_numbers_RowClass } from '../../../dbschema/bl_dgmkt_unsubscribed_numbers.model';

export class DgMktUnsubscribedContainerModel extends BaseContainerModel {
    bl_dgmkt_unsubscribed_numbers : bl_dgmkt_unsubscribed_numbers_RowClass = new bl_dgmkt_unsubscribed_numbers_RowClass();
}

